import React from "react"
import {Doughnut, defaults} from "react-chartjs-2"

const DoughnutChart = (props) => {
  defaults.global.defaultFontFamily = "Helvetica Neue"
  defaults.global.defaultFontSize = 16
  return (
    <Doughnut
      data={{
        datasets: [
          {
            backgroundColor: props.colors,
            data: props.values,
          },
        ],
        labels: props.labels,
      }}
      options={{
        hover: {
          mode: null,
        },
        legend: {
          display: false,
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                userCallback: (value) => "",
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                userCallback: (value) => "",
              },
            },
          ],
        },
        tooltips: {
          enabled: false,
        },
      }}
    />
  )
}

export {DoughnutChart}
